import Axios from '../axios-instance';

const servicePageAPI = {
  getServicePage: body => {
    return Axios.post('/ServiceRecords/Get', body).then(({ data }) => data);
  },
};

export default servicePageAPI;
